module.exports = __webpack_public_path__ + "img/ch23.7a1e2325.jpg";